// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '@/assets/styles/main.scss'

// Vuetify
import { createVuetify } from 'vuetify'

const lightTheme = {
  dark: false,
  colors: {
    primary: '#4f46e5', // Vibrant Indigo
    secondary: '#db2777', // Rose Pink
    accent: '#0891b2', // Cyan
    movies: '#4f46e5',
    books: '#059669',
    audiobooks: '#e11d48',
    comics: '#d97706',
    error: '#dc2626',
    warning: '#d97706',
    info: '#2563eb',
    success: '#059669',
    background: '#f8fafc',
    surface: '#ffffff',
    'surface-variant': '#f1f5f9',
    'on-primary': '#ffffff',
    'on-secondary': '#ffffff',
    'on-surface': '#0f172a',
    'on-background': '#0f172a',
  },
}

const darkTheme = {
  dark: true,
  colors: {
    primary: '#6366f1', // Electric Indigo
    secondary: '#ec4899', // Electric Rose
    accent: '#06b6d4', // Cyan Glow
    movies: '#6366f1',
    books: '#10b981',
    audiobooks: '#f43f5e',
    comics: '#f59e0b',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#38bdf8',
    success: '#10b981',
    background: '#0a0e1a', // Deep Obsidian
    surface: '#121826', // Night Slate
    'surface-variant': '#1a2234',
    'on-primary': '#ffffff',
    'on-secondary': '#ffffff',
    'on-surface': '#f8fafc',
    'on-background': '#f8fafc',
  },
}

// Retrieve saved theme preference if available
const savedTheme = typeof localStorage !== 'undefined' ? localStorage.getItem('cinevault_theme') || 'dark' : 'dark'

export default createVuetify({
  theme: {
    defaultTheme: savedTheme,
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
  defaults: {
    VBtn: {
      style: 'text-transform: none; font-weight: 600; border-radius: 10px;',
      elevation: 0,
    },
    VCard: {
      elevation: 0,
      style: 'border-radius: 16px;',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VChip: {
      style: 'font-weight: 500; border-radius: 8px;',
    },
  },
})

